import { render, staticRenderFns } from "./sorundetay.vue?vue&type=template&id=0f194310&"
import script from "./sorundetay.vue?vue&type=script&lang=js&"
export * from "./sorundetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports